"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _enUS = _interopRequireDefault(require("./en-US.json"));
var _esES = _interopRequireDefault(require("./es-ES.json"));
var _frFR = _interopRequireDefault(require("./fr-FR.json"));
var _jaJP = _interopRequireDefault(require("./ja-JP.json"));
var _koKR = _interopRequireDefault(require("./ko-KR.json"));
var _ptPT = _interopRequireDefault(require("./pt-PT.json"));
var _ruRU = _interopRequireDefault(require("./ru-RU.json"));
var _zhCN = _interopRequireDefault(require("./zh-CN.json"));
var _default = {
  enUS: _enUS["default"],
  'en-US': _enUS["default"],
  esES: _esES["default"],
  'es-ES': _esES["default"],
  frFR: _frFR["default"],
  'fr-FR': _frFR["default"],
  jaJP: _jaJP["default"],
  'ja-JP': _jaJP["default"],
  koKR: _koKR["default"],
  'ko-KR': _koKR["default"],
  ptPT: _ptPT["default"],
  'pt-PT': _ptPT["default"],
  ruRU: _ruRU["default"],
  'ru-RU': _ruRU["default"],
  zhCN: _zhCN["default"],
  'zh-CN': _zhCN["default"]
};
exports["default"] = _default;
module.exports = exports.default;
module.exports.default = exports.default;